import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
// import { useLogin } from "../hook/useLogin.mjs"; // DISABLED: email/password login removed
// import { resendVerificationService } from "../../signup/service/emailVerificationService.mjs"; // DISABLED: email verification removed
import GoogleSignInButton from "../../../components/GoogleSignInButton.mjs";
import EnvironmentCard from "../../../components/EnvironmentCard.mjs";
import { AuthContext } from "../../../authProvider.mjs";
import PageShell from "../../../components/PageShell.mjs";
import { takeReturnPath } from "../../../auth/returnPath.mjs";


export const LoginPage = () => {
    // DISABLED: useLogin() - email/password login form removed
    // const { email, password, setEmail, setPassword, error, successMessage,
    //         errorCode, requiresVerification, retryAfter, isLoading,
    //         handleSubmitLogin } = useLogin();

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    // const [isResending, setIsResending] = useState(false); // DISABLED
    const [oauthError, setOauthError] = useState('');
    const { setAuthenticatedUser, refreshAuthState } = useContext(AuthContext);

    // const hasError = errorCode === "INVALID_CREDENTIALS" || errorCode === "VALIDATION_ERROR"; // DISABLED

    // Handle OAuth error from URL params (Stanford SSO redirect)
    useEffect(() => {
        const errorParam = searchParams.get('error');
        const messageParam = searchParams.get('message');
        if (errorParam || messageParam) {
            setOauthError(messageParam || 'Authentication failed. Please try again.');
        }
    }, [searchParams]);

    const handleOAuthSuccess = async (user) => {
        setAuthenticatedUser(user);
        await refreshAuthState();
        navigate(takeReturnPath() || '/');
    };

    const handleOAuthError = (message) => {
        setOauthError(message);
    };

    // DISABLED: handleResendVerification removed - email signup/verification flow disabled

    return (
        <PageShell variant="entry">
            <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-md border border-white/20 relative overflow-hidden">
                {/* Decorative accent */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-stanford-red"></div>

                <h2 className="text-2xl font-bold text-center mb-6 text-stanford-red">
                    Welcome Back
                </h2>

                {/* OAuth Error Message */}
                {oauthError && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-4">
                        {oauthError}
                    </div>
                )}

                {/* Environment selector: here only while in Test, so anyone the test
                    backend refuses can get back to Production. Admins pick Test
                    from the home page. */}
                <EnvironmentCard />

                {/* Google Sign In → redirects to Stanford SSO */}
                <div className="mb-6">
                    <GoogleSignInButton
                        onSuccess={handleOAuthSuccess}
                        onError={handleOAuthError}
                    />
                </div>

                <div className="pt-4 text-center text-sm text-gray-600">
                    <p>Don't have an account? <Link to="/signup" className="inline-block py-3 sm:py-0 text-stanford-red hover:text-stanford-light-red font-medium">Sign up here</Link></p>
                </div>
            </div>
        </PageShell>
    );
};


